import apiClient from './apiClient';

export const getAdmins = () => apiClient.get('/index');
export const createAdmin = (data) => apiClient.post('/add', data);
export const updateAdmin = (id, data) => apiClient.put(`/edit/${id}`, data);
export const deleteAdmin = (id) => apiClient.delete(`/delete/${id}`);